import { requestWithoutLogout as request } from '@/utils/request'
import { attachmentAdpator } from 'amis-core';
import AmisEditor from './AmisEditor.vue'

const handleApiUrls = ['/appeditor/apimanage/list', '/appeditor/db/list/', '/appeditor/apiurl/listByPagekey', '/test/appointment/statistics']

export default {
  props: {
    ...AmisEditor.props,
    pageId: String,
    appId: String,
    apiType: String
  },
  components: {
    AmisEditor
  },
  model: {
    event: 'change'
  },
  render(h) {
    const props = {}
    Object.keys(AmisEditor.props).forEach(k => {
      if (this[k] !== undefined) {
        props[k] = this[k]
      }
    })
    return h('AmisEditor', {
      props: {
        ...props,
        env: {
          fetcher: config => {
            let additionHeaders = {}
            if (this.pageId) {
              const data = this.$store.getters.getHeaders(this.pageId)
              if (data) {
                Object.keys(data).forEach(key => {
                  additionHeaders[`${this.pageId}${key}`] = data[key]
                })
              }
            }
            const api = !this.appId || !this.pageId || handleApiUrls.find(url => config.url.startsWith(url)) != null ? request({
              url: config.url,
              method: config.method,
              data: config.data,
              headers: { ...additionHeaders, ...config.headers },
              responseType: config.responseType
            }) : request({
              url: `/appeditor/proxy/foward/${props.apiType || 'prod'}/${this.appId}/${this.pageId}${config.url}`,
              method: config.method,
              data: config.data,
              headers: { ...additionHeaders, ...config.headers },
              responseType: config.responseType
            })
            return new Promise((resolve, reject) => {
              api.then(response => {
                const block = res => {
                  const { data } = res
                  if (data.code === 0 || data.status === 0) {
                    resolve(res)
                  } else {
                    const msg = data.msg || data.message || config.messages.failed || config.config.errorMessage
                    reject(config.config.silent ? '' : new Error(msg))
                  }
                }
                config.responseType === 'blob' ? attachmentAdpator(response, null, config).then(res => {
                  block(res)
                }) : block(response)
              }).catch(err => {
                reject(config.config.silent ? '' : err)
              })
            })
          },
          notify: (type, msg) => {
            if (!msg || msg.length === 0) {
              return
            }
            if (props.mode === 'design') {
              // 设计模式下不展示提醒
              return
            }
            if (msg == 'null' || msg == 'undefined') {
              return
            }
            if (type === 'success' && msg === 'success') {
              return
            }
            if (type === 'error' && msg.indexOf('is not a function') >= 0) {
              return
            }
            this.$message[type](msg)
          },
          jumpTo: (to, action) => {
            if (action.blank) {
              window.open(to, '_blank')
              return
            }
            const topest = action.params?.topest ?? false
            const replace = action.params?.replace ?? false
            let location = topest ? window.top.location : window.location
            if (!location) {
              location = window.location
            }
            if (replace) {
              location.replace(to)
            } else {
              location.href = to
            }
          }
        }
      },
      on: {
        change: data => {
          this.$emit('change', data)
        }
      }
    })
  },
}